export default {
  defaultCopiedButtonText: "Link copied!",
  defaultCopyButtonText: "Copy link"
};
